export const environment = {
  production: false,
  apiUrl: 'https://leo-develop.mytrusteddriver.com',
  keycloak: {
    url: 'https://auth-develop.mytrusteddriver.com/auth',
    realm: 'leo',
    clientId: 'court-crm-fe',
  },
  app_path: '',
  name: 'develop',
  honeybadgerApiKey: 'hbp_kR8tdxwU5RlDaS04yNG2mZ8yDr8Uqc1bK8cT',
  googleMapId: '9ae0bda389a1b5152137a757',
  googleApiKey: 'AIzaSyD9hLsKs8OnyyAsUrMQ35sPI1Jd7ugY664',
};
